export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { injured, setting } = this
	let ownerInfo = injured.owner || {}

	let arr = [
		{
			label: '证件类型',
			value: setting.idTypeMap[ownerInfo.idType],
		},
		{
			label: '证件号',
			value: ownerInfo.idNo,
		},
		{
			label: '姓名',
			value: ownerInfo.ownerName,
		},
		{
			label: '性别',
			value: setting.sexMap[ownerInfo.sex],
		},
		{
			label: '年龄',
			value: ownerInfo.age,
		},
		// {
		// 	label: '车主电话',
		// 	value: ownerInfo.ownerPhone,
		// },
	]

	if (ownerInfo.ownerPhone) {
		const phone = ownerInfo.ownerPhone.split(',')
		if (phone.length === 1) {
			arr.push({
				label: '车主电话',
				value: phone[0],
			})
		} else {
			for (const [index, phoneItem] of phone.entries()) {
				arr.push({
					label: `车主电话${index + 1}`,
					value: phoneItem,
				})
			}
		}
	} else {
		arr.push({
			label: '车主电话',
			value: '',
		})
	}

	return {
		title: '车主信息',
		children: arr,
	}
}
